export const schedulingNavItems = [
  {
    name: "Orders",
    path: "/scheduling/orders",
    testId: "nav-item-orders",
    group: "Order Management",
  },
];
